import {Component, HostListener, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { AppComponent } from '../../app.component';
import {Breakpoints, MediaMatcher} from '@angular/cdk/layout';

@Component({
  selector: 'app-profile-password-reset',
  templateUrl: './profile-password-reset.component.html',
  styleUrls: ['../login-form/login-form.component.scss']
})
export class ProfilePasswordResetComponent implements OnInit {
  resetFormSubmitted = false;
  noMatchState = false;
  resetForm = new FormGroup({
    password: new FormControl('', [Validators.required, this.passwordValidator(), this.noMatchStateValidator()]),
    confirm_password: new FormControl('', [Validators.required, this.validatePasswordConfirm, this.noMatchStateValidator()]),
  });
  resetFormErrors = {
    'password': '',
    'confirm_password': ''
  };

  state = 'default';
  resetUuid = '';
  resetStatus = '';
  resetMessage = '';
  resetValidationMessages = {
    'password': {
      'required': 'Password is required',
      'passwordInvalid': 'Your password must be between 8 and 25 characters long',
      'nomatch': ''
    },
    'confirm_password': {
      'required': 'Password confirmation is required',
      'validatePasswordConfirm': 'Passwords do not match'
    }
  };
  pickLoginForm = new FormGroup({
    recover_user: new FormControl('')
  });

  login = ''; // whose pwd will be reset
  accessLogins = [];

  layoutMatches = {
    isHandsetDefaultLayout: false
  }

  @HostListener('window:resize', ['$event']) public onLayoutChange($event) {
    this.setLayoutMatches();
  }

  constructor(
    public application: AppComponent,
    private mediaMatcher: MediaMatcher) {
    this.setLayoutMatches();
  }

  private setLayoutMatches() {
    const handsetBreakPoints = Breakpoints.Handset.split(', ');
    let isHandset = false;
    handsetBreakPoints.forEach(media => {
      if (this.mediaMatcher.matchMedia(media).matches) {
        isHandset = true;
      }
    })
    if (isHandset) {
      this.toggleLayout('isHandsetDefaultLayout')
    } else {
      this.purgeLayout()
    }
  }

  private toggleLayout(key: string) {
    for ( const x in this.layoutMatches ) {
      if (x === key) {
        this.layoutMatches[x] = true;
      } else {
        this.layoutMatches[x] = false;
      }
    }
  }

  private purgeLayout() {
    for ( const x in this.layoutMatches ) {
      if (this.layoutMatches[x]) {
        this.layoutMatches[x] = false;
      }
    }
  }

  ngOnInit() {
    this.application.profilePasswordResetComponent = this;
    // this.application.isActiveRequest = true;
    this.validateResetUuid()
  }

  public validateResetUuid() {
    this.resetUuid = this.application.urlAfterRedirects.split('/')[3];
    this.state = 'validating_uuid';
    this.application.isActiveRequest = true;
    this.application.apiService.validateResetUuid(this.resetUuid).subscribe(
      data => {
        this.processResetUuid(data);
      },
      error =>
        this.showErrorOnPasswordUuid(error)
    );
  }

  public doPasswordReset(uuid: string, login: string, pwd: string) {
    this.application.isActiveRequest = true;
    this.application.apiService.doPasswordReset(uuid, login, pwd).subscribe(
      data => {
        this.processPasswordReset(data);
      },
      error =>
        this.showErrorOnPasswordReset(error)
    );
  }

  public processResetUuid(result) {
    this.application.isActiveRequest = false;
    this.resetStatus = result.result;
    if (result && result.result === 'ok' && result.logins.length === 1) {
      this.state = 'default';
      this.login = result.logins[0].login;
    } else if (result && result.result === 'ok' && result.logins.length > 1) {
      this.state = 'accessreset_picklogin';
      this.accessLogins = result.logins;
    } else if (result && result.result === 'expired') {
      this.state = 'expired';
    } else {
      this.state = 'validating_error';
    }
  }
  public showErrorOnPasswordUuid(error) {
    this.application.isActiveRequest = false;
    this.state = 'validating_error';
    this.resetStatus = 'error';
  }

  private passwordValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      if (!control.value) {
        return null
      }
      if (control.value.length < 8 || control.value.length > 25) {
        return {'passwordInvalid': true}
      }
      return null;
    };
  }

  private noMatchStateValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      return this.noMatchState ? {'nomatch': true} : null;
    };
  }

  public backToSignIn() {
    this.application.router.navigateByUrl('/login');
  }

  public processPasswordReset(result) {
    this.application.isActiveRequest = false;
    if (result && result.result === 'ok') {
      // this.state = 'success';
      this.application.router.navigateByUrl('/login', { state: { passwordChanged: true } });
    } else if (result && result.result === 'invalid' && result.message) {
      this.noMatchState = true;
      this.resetForm.controls['password'].updateValueAndValidity();
      this.resetForm.controls['confirm_password'].updateValueAndValidity();
      this.resetMessage = result.message;
    } else if (result && result.result) {
      this.resetStatus = result.result;
    } else {
      this.resetStatus = 'error';
    }
  }
  public showErrorOnPasswordReset(error) {
    this.application.isActiveRequest = false;
    // this.state = 'validating_error';
    this.resetStatus = 'error';
  }

  public pickedUserReset() {
    this.login = this.pickLoginForm.get('recover_user').value;
    if (!this.login) {
      this.application.appError = 'Please pick which user will change password.';
    } else {
      this.application.appError = '';
      this.state = 'default';
    }
    // if (this.state === 'accessreset_picklogin') {
    //   this.application.doAccessReset(this.pickLoginForm.get('recover_user').value);
    // } else {
    //   if (this.resetForm.get('recover_user').valid) {
    //     this.application.doAccessReset(this.resetForm.get('recover_user').value);
    //   }
    // }
  }

  public onResetSubmit() {
    if (this.application.isActiveRequest) {
      return
    }
    this.resetMessage = '';
    if (this.noMatchState) {
      this.noMatchState = false;
      this.resetForm.controls['password'].updateValueAndValidity()
    }
    this.resetForm.controls['confirm_password'].updateValueAndValidity(); // ensure confirm_password will work
    this.updateResetFormErrorsForDisplay();
    if (this.resetForm.valid) {
      this.application.appError = '';
      this.resetFormSubmitted = true;
      this.doPasswordReset(this.resetUuid, this.login, this.resetForm.controls['password'].value);
    }
  }
  public updateResetFormErrorsForDisplay() {
    for (const field in this.resetFormErrors) {
      if (!this.resetForm.controls[field]) { continue; }
      this.resetFormErrors[field] = '';
      const control = this.resetForm.get(field);
      if (control && !control.valid) {
        const messages = this.resetValidationMessages[field];
        for (const key in control.errors) {
          if (control.errors.hasOwnProperty(key)) {
            this.resetFormErrors[field] = messages[key];
            // this.resetFormErrors[field]+= ' ' + messages[key];
            break; // display only one error message
          }
      }
      }
    }
  }

  validatePasswordConfirm(c: FormControl) {
    if (c.parent && c.parent.controls['password'].value !== c.value) {
      return { validatePasswordConfirm: false };
    } else {
      return null;
    }
  }

}
